import React, { useEffect } from "react";
import Modal from "react-modal";

// Autoplay blocker: don’t add autoplay for Open University videos
const shouldAutoplay = (iframeSrc) => {
    const blockAutoplayDomains = ["player.open.ac.uk", "media-podcast.open.ac.uk"];
    try {
        const url = new URL(iframeSrc);
        return !blockAutoplayDomains.some((domain) => url.hostname.includes(domain));
    } catch (e) {
        return true; // fallback: allow autoplay if URL can't be parsed
    }
};

const VideoModal = ({ isOpen, onClose, videoUrl }) => {

    useEffect(() => {
        if (typeof document !== 'undefined') {
            Modal.setAppElement('#root'); // Set the app element for accessibility
        }
        // This is important for screen readers
        // and to hide the background content when the modal is open.
    }, []);

    // Append autoplay only if it should be allowed
    const iframeSrc =
        shouldAutoplay(videoUrl) && !videoUrl.includes("autoplay=")
            ? `${videoUrl}${videoUrl.includes("?") ? "&" : "?"}autoplay=1`
            : videoUrl;
    const isLandscape = window.screen.orientation?.type?.includes("landscape");

    const customStyles = {
        content: {
            padding: '0px',
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            border: "none",
            background: "none",

            // Optional: responsive styling
            inset: '50% auto auto 50%',
            aspectRatio: '16 / 9',
            maxWidth: '100vw',
            maxHeight: '100vh',
            overflow: 'hidden',
        },
        overlay: {
            zIndex: 1000,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            backdropFilter: 'blur(5px)',
        },
    };


    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            contentLabel="Video Modal"
            style={customStyles}
        >
            <div className="ou-video-modal-iframe-wrapper" style={isLandscape ? {objectFit: 'contain', height: 'auto', width: '70vw'} : {height: '90vh', width: '90vw'}}>
                <iframe
                    width="100%"
                    height="100%"
                    src={iframeSrc}
                    title="Video Player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                ></iframe>
                <button className="ou-video-modal-close-button" onClick={onClose}>X</button>
            </div>
        </Modal>
    );
};

export default VideoModal;
